/**
 * <cart-items> — listens for `cart:update` and swaps its own innerHTML
 * from the rendered `cart-items` section in the response. Both the cart
 * page and the mini-cart drawer mount instances; each updates itself on
 * the same event. Server-rendered HTML is the single source of truth.
 *
 * Replaces the IIFE `commonCart.buildLineItems` / `getCartHtml` plumbing.
 *
 * Source path: theme/js/components/cart-items.esm.js
 * Built name : ./cart-items.js
 *
 * AI: Entirely written by AI
 * Date: 2026-05-07
 * Model: Claude Opus 4.7
 * Updated: 2026-05-07 (Claude Opus 4.7) — section id + parseSection
 *   imported from core/sections.esm.js.
 *
 */

import { log } from './log.js';
import { SECTION_CART_ITEMS, parseSection } from './sections.js';

class CartItems extends HTMLElement {
  constructor() {
    super();
    this._onCartUpdate = this._onCartUpdate.bind(this);
  }

  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    document.addEventListener('cart:update', this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this._onCartUpdate);
  }

  _onCartUpdate(event) {
    const sections = event && event.detail && event.detail.sections;
    const parsed = parseSection(sections && sections[SECTION_CART_ITEMS], SECTION_CART_ITEMS);
    if (!parsed) return;
    this.innerHTML = parsed.innerHTML;
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

log('[Cart] <cart-items> registered');
